<template>
  <div>
    <MayoBackground />
    <div class="relative">
      <page-header :hide-downloads="true"></page-header>

      <top />
      <flow />
      <Content>
        <template #inputs>
          <payment
            :price="$t('fellowship.price.price-mayo')"
            plan-key="mayo"
            :country-code="countryCode"
          />
        </template>
      </Content>

      <page-footer></page-footer>
    </div>
  </div>
</template>

<script>
const kLanguagesAllowedDefault = ['en', 'ja'];
const LocaleToCountryCodes = { ja: 'JP', en: 'IN' };

import MayoBackground from '../../../../../components/Payments/Program/Fellowship/Mayo/Background';
import PageHeader from '../../../../../components/LP/Fellowship/Mayo/Header';

import Top from '../../../../../components/Payments/Program/Fellowship/Mayo/Top';
import Flow from '../../../../../components/Payments/Program/Fellowship/Mayo/FlowPayment';
import Content from '../../../../../components/Payments/Program/Fellowship/Mayo/Content';
import Payment from '../../../../../components/Payments/Program/Fellowship/Payment';

import PageFooter from '../../../../../components/LP/Footer';

export default {
  components: {
    MayoBackground,
    PageHeader,
    Top,
    Flow,
    Content,
    Payment,
    PageFooter,
  },
  props: {
    title: { type: String, default: () => '' },
    allowedLang: { type: Array, default: () => kLanguagesAllowedDefault },
    planKey: { type: String, default: () => '' },
  },
  data() {
    const lang = this.$route.params.lang;

    return {
      countryCode: lang in LocaleToCountryCodes ? LocaleToCountryCodes[lang] : 'IN',
    };
  },
  created() {
    const requestLang = this.$route.params.lang;

    if (!this.allowedLang.includes(requestLang)) {
      this.$router.push({ name: this.$route.name, params: { lang: this.allowedLang[0] } });
      return;
    }

    this.setLocale(requestLang);
  },
};
</script>
